'use strict';

const routes = [
  {
    name: "login",
    path: "/login",
    component: () => import('@/views/login'),
    children: []
  },
  {
    name: "register",
    path: "/register",
    component: () => import('@/views/register'),
    
  },
   {
    name: 'index',
    path: '/',
    component: () => import('@/views/index'),
    children: [
      {
        name: "home",
        path: "/",
        component: () => import('@/views/home/home'),
        children: []
      },
      {
        name: "home",
        path: "/home",
        component: () => import('@/views/home/home'),
        children: []
      },
      {
        name: "product",
        path: "/product",
        component: () => import('@/views/product/product'),
        children: []
      },
      {
        name: "case",
        path: "/case",
        component: () => import('@/views/case/case'),
        children: []
      }, {
        name: "guide",
        path: "/guide",
        component: () => import('@/views/guide/guide'),
        children: []
      }, {
        name: "experience",
        path: "/experience",
        component: () => import("@/views/experience/experience"),
      }, , {
        name: "about",
        path: "/about",
        component: () => import("@/views/about/about"),
      }, {
        name: "caseDetail",
        path: "/caseDetail",
        component: () => import('@/views/case/caseDetail'),
      },
      {
        name: "bannerDetail",
        path: "/bannerDetail",
        component: () => import("@/views/home/bannerDetail")
      },
      {
        name: "advisory",
        path: "/advisory",
        component: () => import("@/views/about/advisory"),
      },
      {
        name: "talent",
        path: "/talent",
        component: () => import("@/views/about/talent"),
      },
      {
        name: "advisoryDetail",
        path: "/advisoryDetail",
        component: () => import("@/views/about/advisoryDetail"),
      }
      // {
      //   name: "CompanyDetail",
      //   path: "/CompanyDetail",
      //   component: () => import("@/components/CompanyDetail"),
      //   children: []
      // },
      // {
      //   name: "example",
      //   path: "/example",
      //   component: () => import('@/components/Examples')
      // }, {
      //   name: "realize",
      //   path: "/realize",
      //   component: () => import('@/components/Realize'),
      // }
    ]
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js